module.exports = __webpack_public_path__ + "static/media/flag-arrow.c5233062.svg";